/* You can add your custom scripts here */



/* =========================================================
   COLLECTION DESCRIPTION — COLLAPSE (MOBILE ONLY) — HAULA (TARGET BY TEXT)
   ========================================================= */
(function () {
  const MQ = window.matchMedia('(max-width: 989px)');

  function isCollectionPage() {
    return (
      document.body.className.includes('template-collection') ||
      window.location.pathname.includes('/collections/')
    );
  }

  function setup() {
    if (!MQ.matches) return;
    if (!isCollectionPage()) return;

    const main = document.querySelector('main');
    if (!main) return;

    // Frases que existem no seu texto (do print)
    const needle1 = 'Blending the fluidity of natural stone';
    const needle2 = 'premium English Bone China';

    // acha o container que contém o texto (bem parecido com o que o debug marcou)
    const blocks = Array.from(main.querySelectorAll('section, div, article'));
    const target =
      blocks.find(el => el.innerText && el.innerText.includes(needle1)) ||
      blocks.find(el => el.innerText && el.innerText.includes(needle2));

    if (!target) {
      console.log('[RM] target not found');
      return;
    }

    // evita duplicar
    if (target.dataset.rmCollapseReady === '1') return;
target.dataset.rmCollapseReady = '1';
target.classList.add('rm-collection-head');


    // pega os parágrafos dentro do bloco
    const ps = Array.from(target.querySelectorAll('p'))
      .filter(p => p.innerText && p.innerText.trim().length > 20);

    if (ps.length < 2) {
      console.log('[RM] not enough paragraphs to collapse');
      return;
    }

    // cria wrapper e move os parágrafos para dentro
    const wrap = document.createElement('div');
    wrap.className = 'rm-collection-desc-wrap rm-collection-desc is-collapsed';

    ps[0].parentNode.insertBefore(wrap, ps[0]);
    ps.forEach(p => wrap.appendChild(p));

    // cria botão
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rm-collection-desc-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';

    // tenta inserir o botão antes do "X products" se existir dentro do target
    const productsLine = Array.from(target.querySelectorAll('*'))
      .find(el => el.childElementCount === 0 && /(\d+)\s+products/i.test(el.textContent || ''));

    if (productsLine) {
      productsLine.parentNode.insertBefore(btn, productsLine);
    } else {
      wrap.after(btn);
    }

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));

      if (expanded) {
        wrap.classList.add('is-collapsed');
        btn.textContent = 'Read more';
      } else {
        wrap.classList.remove('is-collapsed');
        btn.textContent = 'Read less';
      }
    });

    console.log('[RM] collapse applied ✅');
  }

  document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);
})();













